module.exports = "/images/jonas.jpg?69129c6cf4ba58e0066bf24904b69dc8";